import React from 'react';
import { Moon, Sun } from 'lucide-react';

interface DarkModeSwitcherProps {
  isDark: boolean;
  onToggle: () => void;
}

// Công tắc giao diện tối của admin: nút tròn 40px nền xám nhẹ như nút thông báo.
const DarkModeSwitcher = ({ isDark, onToggle }: DarkModeSwitcherProps) => (
  <button
    type="button"
    className="adm-icon-btn"
    aria-pressed={isDark}
    aria-label={isDark ? 'Tắt giao diện tối' : 'Bật giao diện tối'}
    title={isDark ? 'Tắt giao diện tối' : 'Bật giao diện tối'}
    onClick={onToggle}
  >
    {isDark ? <Sun size={20} aria-hidden="true" /> : <Moon size={20} aria-hidden="true" />}
  </button>
);

export default DarkModeSwitcher;
